import React from 'react'
import { Link } from 'gatsby'
import { Builder, withChildren } from '@builder.io/react'
import ls from 'local-storage'

export default function WhereToBuy(props) {
    const { children, url } = props
    const country = ls.get('country')
    
    if (country === 'US' && url) {
        return (
            <a href={url} target="_blank" rel="noreferrer">
                {children}
            </a>
        )
    } else {
        return (
            <Link to='/dealers'>
                {children}
            </Link>
        )
    }
}

Builder.registerComponent(withChildren(WhereToBuy), {
    name: 'Where To Buy',
    inputs: [
        {
            name: 'url',
            type: 'string',
        }
    ]
})
